module.exports = __webpack_public_path__ + "media/images/visualdefault-d7c8fc1b.png";